import React, { useEffect, useState } from "react";
import { Button, Input, Table } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";

import ActionButtons from "../ActionButtons/ActionButtons";
import { history, offerResponeColumns, ROLES } from "../../utils";
import { ResponseOfferTableType } from "../../models";
import connector from "./Container";

const { Search } = Input;

const OfferResponses = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { offerResponses, loggedUser } = state;

  const [searchOffer, setSearchOffer] = useState("");
  const [selectedOffer, setSelectedOffer] = useState<
    ResponseOfferTableType[] | null
  >(null);

  useEffect(() => {
    actions.getOfferResponses();
  }, []);

  const rowSelection = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: ResponseOfferTableType[]
    ) => {
      setSelectedOffer(selectedRows);
    },
  };

  const navigateToDetails = () => {
    if (!selectedOffer) {
      return;
    }
    history.navigate(`/offer-request/${selectedOffer[0].key}/responses`);
  };

  const handleDeleteOffer = () => {
    if (!selectedOffer) {
      return;
    }

    // Rows are offer requests; delete only their responses, not the request.
    const responseIds = selectedOffer.flatMap((offer) =>
      offer.offerResponse.map((response) => response.id)
    );
    actions.deleteOfferResponse(responseIds);
    setSelectedOffer(null);
  };

  const excelExport = () => {
    actions.exportExcel();
  };

  const pdfExport = (id: string) => {
    actions.exportPdf(id);
  };

  return (
    <div className="p-4">
      <div className="lg:flex justify-between mb-4">
        <div className="sm:flex justify-between w-full">
          <ActionButtons
            navigateToDetails={navigateToDetails}
            handleDelete={handleDeleteOffer}
            selected={selectedOffer}
          />
          {loggedUser?.role === ROLES.S_PREMIUM_ADMIN && (
            <Button
              onClick={excelExport}
              icon={<FileExcelOutlined />}
              htmlType="button"
              className="bg-estimate-success border-estimate-success text-white px-2 text-center rounded-sm mr-4 mt-3 sm:mt-0"
            >
              IZVEZI U EXCEL
            </Button>
          )}
        </div>

        <Search
          className="lg:w-[450px] rounded-l-md rounded-r-sm mt-4 lg:mt-0"
          placeholder="Traži po nazivu zahtjeva za ponudu"
          onSearch={(e) => setSearchOffer(e)}
          enterButton
        />
      </div>
      <Table
        columns={offerResponeColumns(searchOffer, pdfExport)}
        dataSource={offerResponses}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default OfferResponses;
